import React from 'react';
import { AwardIcon, BookOpenIcon, HeadphonesIcon, BarChart4Icon, LayersIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
export const RewardsSystemSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-1257">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-5 border-l-4 border-[#d4af37] pl-4" data-id="element-1258">
        Beloningssysteem: Betekenisvolle Gamification
      </h2>
      <div className="flex items-center mb-5" data-id="element-1259">
        <AwardIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-1260" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-1261">
          Ons beloningssysteem vormt de kern van de gamification-strategie, met
          functionele beloningen die directe waarde bieden.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-1262">
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-1263">
          <div className="flex items-start mb-2" data-id="element-1264">
            <div className="w-8 h-8 rounded-full bg-white border border-[#d4af37] flex items-center justify-center mr-3 mt-1" data-id="element-1265">
              <BookOpenIcon className="w-4 h-4 text-[#d4af37]" data-id="element-1266" />
            </div>
            <div data-id="element-1267">
              <h3 className="text-base font-light text-[#333333] mb-1" data-id="element-1268">
                Expertcontent
              </h3>
              <p className="text-xs text-[#666666] leading-relaxed" data-id="element-1269">
                <span className="text-[#d4af37] font-medium" data-id="element-1270">
                  Na 7 check-ins
                </span>{' '}
                ontgrendel je mini-cursussen van experts.
              </p>
            </div>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-1271">
            <div className="flex items-center justify-between mb-2" data-id="element-1272">
              <p className="text-xs font-medium text-[#666666]" data-id="element-1273">
                Cursus: Perfectie & Werk
              </p>
              <Badge label="Vrijgespeeld" variant="filled" icon={<AwardIcon className="w-2.5 h-2.5" data-id="element-1275" />} data-id="element-1274" />
            </div>
            <div className="space-y-2" data-id="element-1276">
              <div className="flex items-center" data-id="element-1277">
                <div className="w-5 h-5 rounded-full bg-[#d4af37] text-white flex items-center justify-center mr-2 text-xs" data-id="element-1278">
                  1
                </div>
                <p className="text-xs text-[#666666]" data-id="element-1279">
                  Herken perfectionisme (8 min)
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-1280">
          <div className="flex items-start mb-2" data-id="element-1281">
            <div className="w-8 h-8 rounded-full bg-white border border-[#d4af37] flex items-center justify-center mr-3 mt-1" data-id="element-1282">
              <BarChart4Icon className="w-4 h-4 text-[#d4af37]" data-id="element-1283" />
            </div>
            <div data-id="element-1284">
              <h3 className="text-base font-light text-[#333333] mb-1" data-id="element-1285">
                Gepersonaliseerde Inzichten
              </h3>
              <p className="text-xs text-[#666666] leading-relaxed" data-id="element-1286">
                <span className="text-[#d4af37] font-medium" data-id="element-1287">
                  Na een weekreeks
                </span>{' '}
                ontvang je visualisaties van je voortgang.
              </p>
            </div>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-1288">
            <div className="flex items-center justify-between mb-2" data-id="element-1289">
              <p className="text-xs font-medium text-[#666666]" data-id="element-1290">
                Weekbalans Overzicht
              </p>
              <Badge label="Nieuw" variant="filled" icon={<AwardIcon className="w-2.5 h-2.5" data-id="element-1292" />} data-id="element-1291" />
            </div>
            <div className="bg-[#f7f3ef] rounded-lg p-2" data-id="element-1293">
              <div className="h-16 flex items-end justify-between px-2" data-id="element-1294">
                <div className="w-1/7 h-[30%] bg-[#d4af37] opacity-60 rounded-t" data-id="element-1295"></div>
                <div className="w-1/7 h-[45%] bg-[#d4af37] opacity-70 rounded-t" data-id="element-1296"></div>
                <div className="w-1/7 h-[25%] bg-[#d4af37] opacity-60 rounded-t" data-id="element-1297"></div>
                <div className="w-1/7 h-[60%] bg-[#d4af37] opacity-80 rounded-t" data-id="element-1298"></div>
                <div className="w-1/7 h-[75%] bg-[#d4af37] opacity-90 rounded-t" data-id="element-1299"></div>
                <div className="w-1/7 h-[65%] bg-[#d4af37] rounded-t" data-id="element-1300"></div>
                <div className="w-1/7 h-[80%] bg-[#d4af37] rounded-t" data-id="element-1301"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-1302">
          <div className="flex items-start mb-2" data-id="element-1303">
            <div className="w-8 h-8 rounded-full bg-white border border-[#d4af37] flex items-center justify-center mr-3 mt-1" data-id="element-1304">
              <HeadphonesIcon className="w-4 h-4 text-[#d4af37]" data-id="element-1305" />
            </div>
            <div data-id="element-1306">
              <h3 className="text-base font-light text-[#333333] mb-1" data-id="element-1307">
                Functionele Tools
              </h3>
              <p className="text-xs text-[#666666] leading-relaxed" data-id="element-1308">
                <span className="text-[#d4af37] font-medium" data-id="element-1309">
                  Bij consistente check-ins
                </span>{' '}
                ontgrendel je praktische tools.
              </p>
            </div>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-1310">
            <div className="flex items-center justify-between mb-2" data-id="element-1311">
              <p className="text-xs font-medium text-[#666666]" data-id="element-1312">
                Soundscape Mixer
              </p>
              <Badge label="Vrijgespeeld" variant="filled" icon={<AwardIcon className="w-2.5 h-2.5" data-id="element-1314" />} data-id="element-1313" />
            </div>
            <div className="flex items-center justify-between bg-[#f7f3ef] rounded-lg p-2" data-id="element-1315">
              <div className="flex items-center" data-id="element-1316">
                <div className="w-6 h-6 rounded-full bg-[#d4af37] bg-opacity-20 flex items-center justify-center mr-2" data-id="element-1317">
                  <HeadphonesIcon className="w-3 h-3 text-[#d4af37]" data-id="element-1318" />
                </div>
                <span className="text-xs text-[#666666]" data-id="element-1319">Oceaangolven</span>
              </div>
              <div className="w-16 h-1.5 bg-[#d4af37] rounded-full" data-id="element-1320"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-1321">
        <h3 className="text-lg font-light text-[#333333] mb-3 flex items-center justify-center" data-id="element-1322">
          <LayersIcon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-1323" />
          Beloningscyclus & Principes
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3" data-id="element-1324">
          <div className="bg-white p-3 rounded-lg text-center" data-id="element-1325">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-1326">
              <span className="text-[#d4af37] block mb-1" data-id="element-1327">1</span>
              Check-in
            </p>
            <p className="text-xs text-[#666666]" data-id="element-1328">Consistente activiteit</p>
          </div>
          <div className="bg-white p-3 rounded-lg text-center" data-id="element-1329">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-1330">
              <span className="text-[#d4af37] block mb-1" data-id="element-1331">2</span>
              Beloning
            </p>
            <p className="text-xs text-[#666666]" data-id="element-1332">Functionaliteit vrijspelen</p>
          </div>
          <div className="bg-white p-3 rounded-lg text-center" data-id="element-1333">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-1334">
              <span className="text-[#d4af37] block mb-1" data-id="element-1335">3</span>
              Waarde
            </p>
            <p className="text-xs text-[#666666]" data-id="element-1336">
              Directe therapeutische waarde
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg text-center" data-id="element-1337">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-1338">
              <span className="text-[#d4af37] block mb-1" data-id="element-1339">4</span>
              Terugkeer
            </p>
            <p className="text-xs text-[#666666]" data-id="element-1340">Verhoogde motivatie</p>
          </div>
        </div>
      </div>
    </div>;
};